import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DEFAULT_LOGO = "/brand-logo.svg";

const BrandLogoContext = createContext({ brandLogo: DEFAULT_LOGO });

export const useBrandLogo = () => useContext(BrandLogoContext);

export const BrandLogoProvider = ({ children }) => {
  const [brandLogo, setBrandLogo] = useState(DEFAULT_LOGO);

  const fetchBrandLogo = useCallback(() => {
    axios.get(`${API}/cms/brand-logo`)
      .then(res => {
        if (res.data.brand_logo) {
          let logoUrl = res.data.brand_logo;
          // If it's a relative proxy URL, prepend backend base
          if (logoUrl.startsWith('/api/')) {
            logoUrl = `${BACKEND_URL}${logoUrl}`;
          }
          setBrandLogo(logoUrl);
        } else {
          setBrandLogo(DEFAULT_LOGO);
        }
      })
      .catch(() => {
        setBrandLogo(DEFAULT_LOGO);
      });
  }, []);

  useEffect(() => {
    fetchBrandLogo();
  }, [fetchBrandLogo]);

  return (
    <BrandLogoContext.Provider value={{ brandLogo, setBrandLogo, DEFAULT_LOGO, refreshBrandLogo: fetchBrandLogo }}>
      {children}
    </BrandLogoContext.Provider>
  );
};

export default BrandLogoContext;
